module.exports = __webpack_public_path__ + "0a178033ba50a8b1ea3502f880e410ec.png";